<template>
    <div>
        <div v-show="!saveOrUpdate.visible&&!look.visible">
            <!--搜索表单-->
            <div class="search-box">
                <el-form ref="searchForm" :rules="rules"  :inline="true" :model="searchForm" >
                         <el-form-item label="协议名称:" prop="title">
                            <el-input size="mini" v-model="searchForm.title" placeholder="请输入协议名称"></el-input>
                        </el-form-item>
                         <el-form-item label="适用店面:" prop="shopName">
                            <el-input size="mini" v-model="searchForm.shopName" placeholder="请输入适用店面"></el-input>
                        </el-form-item>
                    <el-form-item>
                        <el-button plain size="mini" type="primary" icon="el-icon-search" id="findBtn" v-display:sysAgreement-find @click="()=>{this.searchForm.pager.page=1;this.submit();}">查询</el-button>
                        <el-button plain size="mini" type="warning" icon="el-icon-refresh-left" plain @click="clear">清空</el-button>
                        <el-button plain size="mini" type="success" icon="el-icon-refresh-left" @click="()=>{this.searchForm.pager.page=1;this.submit();}">刷新</el-button>
                        <el-button plain size="mini" type="primary" v-display:sysAgreement-save icon="el-icon-plus" @click="toSaveOrUpdate" >新增</el-button>
                        <el-dropdown>
                           <el-button type="primary" size="mini" plain style="margin: 0px 10px 0px 10px">
                               批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                           </el-button>
                           <el-dropdown-menu slot="dropdown">
                               <el-dropdown-item v-display:sysAgreement-batchDelete icon="el-icon-delete" @click.native="batchDelete" >批量删除</el-dropdown-item>
                               <el-dropdown-item v-display:sysAgreement-batchUpdate icon="el-icon-delete" @click.native="showBatchUpdateDialog">批量修改</el-dropdown-item>
                               <el-dropdown-item v-display:sysAgreement-leadingIn icon="el-icon-upload" @click.native="leadingInSysAgreement">导入</el-dropdown-item>
                               <el-dropdown-item v-display:sysAgreement-export icon="el-icon-download" @click.native="exportSysAgreement">导出</el-dropdown-item>
                               <el-dropdown-item v-display:sysAgreement-exportField icon="el-icon-download" @click.native="exportSysAgreementDialog">导出选择字段</el-dropdown-item>
                               <el-dropdown-item v-display:sysAgreement-exportModule icon="el-icon-download" @click.native="exportSysAgreementModule('upsertForm')">下载模板</el-dropdown-item>
                           </el-dropdown-menu>
                        </el-dropdown>
                    </el-form-item>
                </el-form>
             </div>
            <!--表格-->
            <el-table border size="mini" class="table-ui" :stripe="true" :data="tableData" @selection-change="changeFun"   @sort-change="sortChange" >
                <el-table-column type="selection" width="40px" style="text-align: center;margin: auto"></el-table-column>
                <el-table-column show-overflow-tooltip prop="title" label="协议名称"></el-table-column>
                <el-table-column show-overflow-tooltip prop="shopName" label="适用店面"></el-table-column>
                <el-table-column show-overflow-tooltip prop="url" label="链接">
                    <template slot-scope="scope">
                        <el-link :href="config.resIp+scope.row.url" target="_blank">签约地址({{config.resIp+scope.row.url}})</el-link>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="updateTime" label="修正时间" sortable="custom" width="100"></el-table-column>
                <el-table-column fixed="right" label="操作" width="80"  >
                    <template slot-scope="scope">
                        <el-dropdown>
                            <span class="el-dropdown-link" style="color: #409EFF">
                            操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-display:sysAgreement-update @click.native="toSaveOrUpdate($event,scope.row.id)">修改</el-dropdown-item>
                                <el-dropdown-item v-display:sysAgreement-look @click.native="toLook($event,scope.row.id)">查看</el-dropdown-item>
                                <el-dropdown-item v-display:sysAgreement-delete @click.native="deleteData(scope.row.id)">删除</el-dropdown-item>
                                <el-dropdown-item v-display:sysAgreement-lookQrcodes @click.native="lookQrcodes(scope.row.id)">查看二维码</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
                <div slot="empty"><no-data></no-data></div>
            </el-table>
            <el-pagination
                    style="margin-top: 10px;padding-bottom: 20px;"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="searchForm.pager.totalCount"
                    :page-size="searchForm.pager.pageSize"
                    :current-page.sync="searchForm.pager.page"
                    :page-sizes="[10, 20, 30, 40, 50, 100]"
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    @prev-click="currentChange"
                    @next-click="currentChange"
            ></el-pagination>
            <el-dialog :close-on-click-modal="false" :title="dialogExcel.title"   width="650px" :visible.sync="dialogExcel.dialogFormVisible">
                <div v-if="dialogExcel.title=='导入结果'">
                <el-badge :value="cnt" class="item" style="margin: 10px 20px 10px 0px">
                    <el-button size="mini">导入总数</el-button>
                </el-badge>
                <el-badge :value="successCnt" class="item" type="primary" style="margin: 10px 20px 10px 10px">
                    <el-button size="mini">导入成功</el-button>
                </el-badge>
                <el-badge :value="errorNumber" class="item" type="warning" style="margin: 10px 20px 10px 10px">
                    <el-button size="mini">导入失败</el-button>
                </el-badge>
                <!--表格-->
                <el-table border size="mini" v-show="errorNumber>0" :stripe="true" :data="uploadData" style="margin-top: 10px">
                            <el-table-column show-overflow-tooltip prop="title" label="协议名称"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="content" label="协议内容"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="shopName" label="适用店面"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="url" label="链接"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" sortable="custom"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="updateTime" label="更新时间" sortable="custom"></el-table-column>
                </el-table>
            </div>
                <div v-if="dialogExcel.title=='导入'">
                    <el-upload class="lead-in-th"
                        style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #4dbd73 ;"
                        :action="uploadUrl"
                        :headers="headers"
                        multiple
                        :show-file-list="false"
                        :on-success="handleSysAgreementSuccess"
                        :before-upload="beforeSysAgreementUpload">
                        <div class="" style="width: 440px;height: 50px;">导入</div>
                    </el-upload>
                    <div class="lead-in-th" @click="exportSysAgreementModule('upsertForm')" style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #fff ;background-color: #51c993">下载模板</div>
                </div>
            </el-dialog>
            <!--选择字段导出-->
            <el-dialog :close-on-click-modal="false"  :title="exportDialogExcel.title"  width="650px" :visible.sync="exportDialogExcel.dialogFormVisible">
               <div style="height: 400px;overflow-y: auto;width: 100%" >
                   <!--表格-->
                   <el-table border size="mini"  :stripe="true" :data="tableFieldData" style="margin-top: 20px" @selection-change="changeTableFieldFun"  >
                       <el-table-column type="selection" fixed="left" width="40"></el-table-column>
                       <el-table-column prop="key" label="英文字段名" ></el-table-column>
                       <el-table-column prop="name" label="中文字段名" ></el-table-column>
                       <el-table-column prop="newName" label="重命名字段" >
                           <template slot-scope="scope">
                               <el-input  placeholder="重命名字段" maxlength="20" size="mini" v-model="tableFieldData[scope.$index].newName"></el-input>
                           </template>
                       </el-table-column>
                   </el-table>
               </div>
                <div slot="footer" class="dialog-footer">
                    <el-button plain size="mini" @click="exportDialogExcel.dialogFormVisible = false">取 消</el-button>
                    <el-button plain size="mini" icon="el-icon-download"  type="success" @click="exportSysAgreementByField">确认导出</el-button>
                </div>
            </el-dialog>
            <!--批量修改-->
            <el-dialog :close-on-click-modal="false" :title="batchDialog.title"   width="900px" :visible.sync="batchDialog.dialogFormVisible">
                <el-form class="upsertForm"  :model="upsertForm" ref="upsertForm" label-width="80px" :inline="true">
                    <el-form-item label="协议名称" prop="title">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.title" placeholder="请输入协议名称" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="协议内容" prop="content">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.content" placeholder="请输入协议内容" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="适用店面" prop="shopName">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.shopName" placeholder="请输入适用店面" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="链接" prop="url">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.url" placeholder="请输入链接" auto-complete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="mini" @click="batchDialog.dialogFormVisible = false">取 消</el-button>
                    <el-button size="mini" type="primary" @click="batchUpdate('upsertForm')">确 定</el-button>
                </div>
            </el-dialog>
            <!--查看二维码-->
            <el-dialog :close-on-click-modal="false" title="查看二维码"  width="600px" :visible.sync="lookQrcode.dialogFormVisible">
                <div style="text-align: center;margin: auto">
                    <img style="width: 400px; height: 400px" :src="lookQrcode.img"></img>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="mini" @click="lookQrcode.dialogFormVisible = false">取 消</el-button>
                    <el-button size="mini" type="primary" @click="downPng(lookQrcode.img)">下载二维码</el-button>
                </div>
            </el-dialog>
        </div>
        <save-or-update-sys-agreement v-if="saveOrUpdate.visible" v-bind="saveOrUpdate" @closeSaveOrUpdate="closeSaveOrUpdate"></save-or-update-sys-agreement>
        <look-sys-agreement v-if="look.visible" v-bind="look" :visible.sync="look.visible"></look-sys-agreement>

    </div>
</template>

<script>
    import axios from 'axios';
    import saveOrUpdateSysAgreement from './saveOrUpdateSysAgreement';
    import lookSysAgreement from './lookSysAgreement';
    import fileDownload from "js-file-download";
    import noData from '@/components/noData/noData';
    import ElImage from "../../../../node_modules/element-ui/packages/image/src/main.vue";
    export default {
        name: "sysAgreement",
        components:{
            ElImage,
            saveOrUpdateSysAgreement,lookSysAgreement,noData},
        data() {
            return {
                searchForm:{
                      title: '',
                      content: '',
                      shopId: '',
                      shopName: '',
                      url: '',
                      createTime: '',
                      updateTime: '',
                    keyWord:'',
                    pager:{
                        sortField:'create_time',
                        sortOrder:'desc',
                        page:1,
                        pageSize:10,
                        totalCount:0,
                        keyWordField:'',
                    }
                },
                upsertForm:{
                        id:'',
                        title:'',
                        content:'',
                        shopId:'',
                        shopName:'',
                        url:'',
                        createTime:'',
                        updateTime:''
                },
                tableData: [],
                saveOrUpdate:{
                    visible:false,
                    title:'增加',
                    id:''
                },
                look:{
                    visible:false,
                    id:''
                },
                headers: {
                    token: this.$store.getters.getToken
                },
                rowData: [],
                cnt: '',
                successCnt: '',
                errorNumber: '',
                uploadData: [],
                uploadUrl: `${home}/sysAgreement/importByExcel`,
                dialogExcel:{
                    dialogFormVisible:false,
                    title:'导入'
                },
                rules: {
                          title: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          content: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          shopId: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          shopName: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          url: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          createTime: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          updateTime: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                },
                exportDialogExcel:{
                    dialogFormVisible:false,
                    title:'导出选择字段',
                    id:'',
                },
                tableFieldData:[],
                fieldData:[],
                excelParam:{
                    data:'',
                    excelExportList:''
                },
                batchDialog:{
                   dialogFormVisible:false,
                   title:'批量修改'
               },
                lookQrcode:{
                    dialogFormVisible:false,
                    img:''
                },
                config:config
            }
        },
        created(){
        },
        mounted(){
            let findBtn=document.querySelector('#findBtn');
            findBtn&&this.submit();
        },
        methods: {
            changeTableFieldFun(row) {
                this.fieldData = [];
                for (var i = 0; i < row.length; i++) {
                    this.fieldData.push(row[i]);
                }
            },
            changeFun(row) {
                this.rowData = [];
                for (var i = 0; i < row.length; i++) {
                    this.rowData.push(row[i].id);
                }
            },
            sortChange({ column, prop, order }){
                this.searchForm.pager.sortField=prop;
                this.searchForm.pager.sortOrder=order?order.replace(/ending$/,''):'';
                this.submit();
            },
            sizeChange(pageSize){
                this.searchForm.pager.pageSize=pageSize;
                this.submit();
            },
            currentChange(page){
                this.searchForm.pager.page=page;
                this.submit();
            },
            toSaveOrUpdate($event,id){
                if(id){
                    this.saveOrUpdate.title='修改';
                    this.saveOrUpdate.id=id;
                }else{
                    this.saveOrUpdate.title='增加';
                }
                this.saveOrUpdate.visible=true;
            },
            closeSaveOrUpdate(data){
                this.saveOrUpdate.visible=false;
                data&&this.submit();
            },
            toLook($event,id){
                this.look={
                    visible:true,
                    id:id
                }
            },
            deleteData(id){
                this.$confirm('删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios({
                        url: `${home}/sysAgreement/deleteSysAgreement/${id}`,
                        method: 'GET'
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.submit();
                    }).catch(error => {

                    })

                }).catch(() => {

                });

            },
            submit(){
                axios({
                    url:`${home}/sysAgreement/findSysAgreementsByCondition`,
                    method:'POST',
                    data:this.searchForm
                }).then(res=>{
                    if(res.data.length===0&&this.searchForm.pager.page>1&&res.totalCount>0){
                        this.searchForm.pager.page--;
                        this.submit();
                    }else{
                        this.tableData=res.data;
                        this.searchForm.pager.totalCount=res.totalCount;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            clear(){
                this.$refs['searchForm'].resetFields();
            },
            leadingInSysAgreement() {
                this.dialogExcel.dialogFormVisible = true;
                this.dialogExcel.title = '导入';
            },
            exportSysAgreement() {
                axios({
                    url: `${home}/sysAgreement/exportSysAgreement`,
                    method: "POST",
                    data: this.searchForm,
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "协议管理.xls");
                });
            },
            exportSysAgreementModule() {
                axios({
                    url: `${home}/sysAgreement/exportSysAgreementModule`,
                    method: "GET",
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "协议管理模板.xls");
                });

            },
            handleSysAgreementSuccess(res, file) {
                this.loading.close();
                this.dialogExcel.dialogUploadVisible = false;
                if (res.result.success== true) {
                    if(res.data.successCnt>0){
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入成功",
                            type: "success"
                        });
                        this.submit();
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }else{
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入失败",
                            type: "warning"
                        });
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }
                } else{
                    this.$message({
                        message: "模板有误或数据为空",
                        type: "error"
                    });
                    this.dialogExcel.dialogUploadErrorVisible = true;
                }
            },
            beforeSysAgreementUpload(file) {
                this.loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                const extension = file.name.split(".")[1] === "xls";
                const extension2 = file.name.split(".")[1] === "xlsx";
                if (!extension && !extension2) {
                    this.loading.close();
                    this.$message.error("上传模板只能是 xls、xlsx 格式!");
                }
                return extension || extension2;
            },
            batchDelete(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量删除吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    axios({
                        url: `${home}/sysAgreement/batchDeleteSysAgreement`,
                        method: "post",
                        data: {
                            rowData: this.rowData
                        }
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "删除成功!"
                        });
                        this.submit();
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "删除失败!"
                    });
                });
            },
            exportSysAgreementDialog(){
                axios({
                    url: `${home}/sysAgreement/getSysAgreementTableField`,
                    method: "GET",
                }).then(res => {
                    this.tableFieldData = res.data;
                    this.exportDialogExcel.dialogFormVisible = true;
                    this.exportDialogExcel.title = '导出选择字段';
                    this.exportDialogExcel.id = this.id;
                });
            },
            exportSysAgreementByField() {
                if(this.fieldData.length<=0 ){
                    this.$message({
                        type: "error",
                        message: "请选择需要导出的字段!"
                    });
                }else{
                    this.excelParam.data = this.searchForm;
                    this.excelParam.excelExportList = this.fieldData;
                    axios({
                        url: `${home}/sysAgreement/exportSysAgreementByField`,
                        method: "POST",
                        data: this.excelParam,
                        responseType: "arraybuffer"
                    }).then(res => {
                        fileDownload(res, "协议管理.xls");
                    });
                }

            },
            showBatchUpdateDialog(){
                if(this.rowData.length>0){
                    this.batchDialog.dialogFormVisible=true;
                    this.batchDialog.title='批量修改';
                    objUtil.setToDefault(this.upsertForm);
                    this.$nextTick(()=>{
                        this.$refs.upsertForm.clearValidate();
                    });
                }else{
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                }
            },
            batchUpdate(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量修改吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    this.upsertForm.rowData = this.rowData;
                    axios({
                        url: `${home}/sysAgreement/batchUpdateSysAgreement`,
                        method: "post",
                        data: this.upsertForm
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "修改成功!"
                        });
                        this.submit();
                        this.batchDialog.dialogFormVisible=false;
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "修改失败!"
                    });
                });
            },
            lookQrcodes(id){
                axios({
                    url: `${home}/sysAgreement/lookQrCode/${id}`,
                    method: "GET",
                }).then(res => {
                    this.lookQrcode.dialogFormVisible = true;
                    this.lookQrcode.img=res.data;
                }).catch(error => {});
            },
            downPng(img){
                let aLink = document.createElement('a');
                let blob = this.base64ToBlob(img); //new Blob([content]);

                let evt = document.createEvent("HTMLEvents");
                console.log("点击下载",evt)
                evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
                aLink.download = "二维码.png";
                aLink.href = URL.createObjectURL(blob);

                // aLink.dispatchEvent(evt);
                aLink.click()
            },
            //base64转blob
            base64ToBlob(code) {
                let parts = code.split(';base64,');
                let contentType = parts[0].split(':')[1];
                let raw = window.atob(parts[1]);
                let rawLength = raw.length;

                let uInt8Array = new Uint8Array(rawLength);

                for (let i = 0; i < rawLength; ++i) {
                    uInt8Array[i] = raw.charCodeAt(i);
                }
                return new Blob([uInt8Array], {type: contentType});
            }
        }
    }
</script>
